<script setup lang="ts">
import {Dialog} from "@/Components/Library";
import TermsAndConditionsText from "./TermsAndConditionsText.vue";

const model = defineModel<boolean | undefined>();
</script>
<template>
    <Dialog header="Terms and Conditions" modal v-model:visible="model" class="w-full max-w-3xl">
        <div class="prose">
            <TermsAndConditionsText />
        </div>
    </Dialog>
</template>
<style scoped></style>
